module.exports = __webpack_public_path__ + "img/Science.b7fb8f65.jpg";